export const TooltipIcon = ({ height = 29, width = 26 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 26 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_4446_205)">
      <ellipse
        cx="13.0792"
        cy="12.5979"
        rx="9.20099"
        ry="9.20659"
        fill="white"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6921 0.819934C8.19548 1.24501 5.11149 3.1585 3.16698 6.10928C0.596439 10.0102 0.596439 15.1788 3.16698 19.0798C5.38918 22.452 9.06338 24.4382 13.0792 24.4382C17.0974 24.4382 20.768 22.4539 22.9915 19.0798C25.6319 15.0728 25.5538 9.75583 22.7967 5.82175C20.8267 3.01096 17.8276 1.2173 14.4333 0.81998C13.7253 0.737121 12.3735 0.737075 11.6921 0.819934ZM13.8729 4.56628C15.0031 4.76345 15.8132 5.18969 16.6394 6.02193C17.1285 6.51456 17.365 6.8552 17.6218 7.43697C18.3671 9.12548 17.8768 11.3641 16.3529 13.2302C15.6358 14.1083 15.3133 14.9589 15.2651 16.099L15.2392 16.712H13.0792H10.9193L10.8933 16.099C10.8434 14.9176 10.5551 14.1828 9.72433 13.1192C7.78652 10.6383 7.67681 7.94574 9.43798 6.09226C10.6048 4.86422 12.2791 4.28814 13.8729 4.56628ZM15.0941 17.787C15.2123 17.9162 15.2523 18.0015 15.2523 18.1247C15.2523 18.3341 15.1543 18.5244 14.9888 18.6367C14.8672 18.7192 14.7513 18.7245 13.0792 18.7245C11.3134 18.7245 11.298 18.7237 11.155 18.6216C10.7993 18.3677 10.8553 17.8024 11.2529 17.6344C11.3038 17.6129 12.1532 17.5996 13.1406 17.6048L14.9358 17.6142L15.0941 17.787ZM14.123 19.7308C14.3441 19.9336 14.3819 20.183 14.2261 20.4125C14.0507 20.6711 13.9751 20.6894 13.0792 20.6894C12.1833 20.6894 12.1077 20.6711 11.9323 20.4125C11.7766 20.183 11.8143 19.9336 12.0354 19.7308L12.1994 19.5804H13.0792H13.959L14.123 19.7308Z"
      fill="#F9155B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5689 7.46744C15.0254 6.82016 14.2167 6.382 13.4271 6.33478C13.2384 6.32349 13.0946 6.16131 13.1059 5.97252C13.1172 5.78374 13.2793 5.63985 13.4679 5.65113C14.4676 5.71091 15.4438 6.25382 16.0929 7.02691C16.2145 7.17171 16.1957 7.38771 16.051 7.50936C15.9063 7.63101 15.6904 7.61224 15.5689 7.46744Z"
      fill="#F9155B"
    />
    <path
      d="M16.7943 8.14538C16.7943 8.35045 16.6281 8.51669 16.4232 8.51669C16.2182 8.51669 16.0521 8.35045 16.0521 8.14538C16.0521 7.94032 16.2182 7.77408 16.4232 7.77408C16.6281 7.77408 16.7943 7.94032 16.7943 8.14538Z"
      fill="#F9155B"
    />
    <defs>
      <filter
        id="filter0_d_4446_205"
        x="0.586689"
        y="3.39136"
        width="24.9851"
        height="25.2568"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="1.18401"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_4446_205"
        />
        <feOffset dy="3.55204" />
        <feGaussianBlur stdDeviation="1.05377" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.716346 0 0 0 0 0 0 0 0 0 0.219931 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4446_205"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4446_205"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
